import { Dto, DtoWithId } from "@mango/core";
import { Projectregel } from "./projectregel";


@Dto({fullName: "CIJBorculo.Logic.ProjectregelStatusHistorie"})
export class ProjectregelStatusHistorie extends DtoWithId {
	projectregel: Projectregel;
	status: string;
	datum: Date;
}